<template>
  <div class="label">
    <div class="label-content" style="background: transparent;">
      <Table
        :border="false"
        row-key="id"
        :columns="columns"
        :data="groupList"
        max-height='700'
        no-data-text="暂无数据"
      >
        <template slot-scope="{ row, index }" slot="groupName">{{row.description}}</template>
        <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
        <template slot-scope="{ row, index }" slot="action">
          <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
          <span style="display: inline-block;padding: 0 5px;">|</span>
          <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
            <span style="color: #f00;cursor: pointer;">删除</span>
          </Poptip>
        </template>
      </Table>
    </div>
    <!-- 修改展商置顶 -->

    <staffAdd 
      :show="show"
      :groupList="groupList"
      @finish="init()"
      @close="show=false;"
    />

    <staffEdit
      v-if="editShowFlag"
      :show="editShowFlag"
      :groupList="groupList"
      :data="editInfo"
      @close="editShowFlag=false;editInfo={};"
      @finish="init()"
    />

  </div>
</template>

<script>
import staffAdd from "../components/staff-add.vue";
import staffEdit from "../components/staff-edit.vue";
import { mapActions } from "vuex";

export default {
  name: "host-set-staff",
  data() {
    return {
      columns: [
        {
          title: "类型",
          key: "groupName",
          slot: "groupName",
          align: "center",
        },
        {
          title: "排序",
          key: "showIndex",
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      show: false,
      editShowFlag: false,
      editInfo: {},
      groupList: [], // 客服类型
    };
  },
  components: {
    staffAdd,
    staffEdit
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getContactUsByGroup:'hostCommonModule/getContactUsByGroup',
      getContactUs:'hostCommonModule/getContactUs',
      delContactUs:'hostCommonModule/delContactUs'
    }),
    async init() {
      let groupList = await this.getContactUsByGroup();
      if (groupList && groupList.length > 0) {
        this.groupList = groupList;
      }
      console.log("groupList：",this.groupList);
    },
    async delItem(item) { 
      let result = await this.delContactUs(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },

    showAdd() { // 新增
      this.show = true;
    },
    editShow(item) { // 编辑
      this.editShowFlag = true;
      this.editInfo = item;
    },
  }
};
</script>

<style scoped lang="scss">
.label {
  min-width: 1000px;
  min-height: 500px;
  padding: 30px;
}
</style>
